export const CONTACTS_RESET_STATE = 'CONTACTS_RESET_STATE';
export const CONTACTS_CURRENT_ITEM = 'CONTACTS_CURRENT_ITEM';

export const CONTACTS_REQUEST_LOADING = 'CONTACTS_REQUEST_LOADING';
export const CONTACTS_REQUEST_SUCCESS = 'CONTACTS_REQUEST_SUCCESS';
export const CONTACTS_REQUEST_FAILED = 'CONTACTS_REQUEST_FAILED';

export const CONTACTS_CURRENT_ACTION = 'CONTACTS_CURRENT_ACTION';
export const CONTACTS_RESET_ACTION = 'CONTACTS_RESET_ACTION';